<template>
  <v-app class="futuristic-app">

    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy d-block d-sm-none d-lg-block">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Cari nama desa..."
          solo
          flat
          rounded
          clearable
          hide-details
          background-color="#f1f6f5"
          class="header-search mr-3 d-none d-sm-flex"
        />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-home-group </v-icon>
          </div>

          <div>
            <div class="header-info-title">Wilayah Desa</div>
            <div class="header-info-subtitle">{{ selectedKecamatanName || "Memuat..." }} · {{ filteredDesa.length }} desa</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container
        class="py-12 content-layer"
        style="max-width: 1200px; position: relative; z-index: 2"
      >
        <div class="d-flex align-center mb-10 px-4">
          <div class="line-decorator-gold mr-4"></div>
          <h2 class="black--text text-overline letter-spacing-4">
            DATABASE_TERVERIFIKASI
          </h2>
        </div>

        <div class="scrollable-content-area">
          <v-row v-if="filteredDesa.length > 0" class="modern-desa-grid">
            <v-col
              v-for="(item, index) in filteredDesa"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card class="modern-desa-card" ripple @click="goToPotensi(item)">
                <div class="card-glow"></div>

                <div class="desa-header">
                  <div class="icon-wrapper">
                    <v-icon size="28" color="white"> mdi-home-city-outline </v-icon>
                  </div>

                  <div class="desa-badge">VERIFIED</div>
                </div>

                <div class="desa-body">
                  <div class="mini-label">DESA / KELURAHAN</div>

                  <div class="desa-name">
                    {{ item.desa }}
                  </div>

                  <div class="kecamatan-chip">
                    <v-icon size="14" color="#018c74" class="mr-1">
                      mdi-map-marker
                    </v-icon>

                    {{ item.nama_kecamatan }}
                  </div>
                </div>

                <div class="desa-footer">
                  <span class="lihat-text"> Lihat Potensi </span>

                  <div class="arrow-btn">
                    <v-icon size="18" color="white"> mdi-arrow-top-right </v-icon>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-else class="text-center mt-15">
            <v-col>
              <v-icon size="80" color="rgba(207,162,45,0.1)">mdi-database-search</v-icon>
              <div class="black--text opacity-5 mt-4 letter-spacing-4">
                TIDAK ADA DATA DESA
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { getDesa } from "@/api/androidInitApi";

export default {
  data: () => ({
    search: "",
    listDesa: [],
    selectedKecamatanId: null,
    selectedKecamatanName: "",
    particles: [],
    ctx: null,
    animationId: null,
  }),
  computed: {
    filteredDesa() {
      if (!this.listDesa || this.listDesa.length === 0) return [];

      const querySearch = this.search ? this.search.toLowerCase().trim() : "";
      const targetKecId = this.selectedKecamatanId
        ? String(this.selectedKecamatanId)
        : null;

      let results = this.listDesa.filter((item) => {
        const matchesKec = targetKecId ? String(item.id_kecamatan) === targetKecId : true;
        const matchesSearch = item.desa.toLowerCase().includes(querySearch);
        return matchesKec && matchesSearch;
      });

      const uniqueResults = [];
      const map = new Map();
      for (const item of results) {
        if (!map.has(item.desa)) {
          map.set(item.desa, true);
          uniqueResults.push(item);
        }
      }

      return uniqueResults;
    },
  },
  created() {
    this.selectedKecamatanId = this.$route.query.id_kec;
    this.selectedKecamatanName = this.$route.query.nama_kec;
  },
  mounted() {
    this.initParticles();
    this.fetchData();
    window.addEventListener("resize", this.resizeCanvas);
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationId);
    window.removeEventListener("resize", this.resizeCanvas);
  },
  methods: {
    async fetchData() {
      try {
        this.listDesa = (await getDesa()) || [];
        console.log("Data loaded, total BPS records:", this.listDesa.length);
      } catch (e) {
        console.error("API Error:", e);
      }
    },
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      this.ctx = canvas.getContext("2d");
      this.resizeCanvas();
      this.particles = Array.from({ length: 30 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.2,
        vy: (Math.random() - 0.5) * 0.2,
        radius: Math.random() * 2 + 1,
      }));
      this.animate();
    },
    resizeCanvas() {
      const canvas = this.$refs.particleCanvas;
      if (canvas) {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    },
    animate() {
      if (!this.ctx) return;
      this.ctx.clearRect(
        0,
        0,
        this.$refs.particleCanvas.width,
        this.$refs.particleCanvas.height
      );
      this.particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > this.$refs.particleCanvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > this.$refs.particleCanvas.height) p.vy *= -1;
        this.ctx.beginPath();
        this.ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        this.ctx.fillStyle = "rgba(1, 140, 116, 0.3)";
        this.ctx.fill();
      });
      this.animationId = requestAnimationFrame(this.animate);
    },
    goToPotensi(item) {
      this.$router.push({
        name: "list_potensi",
        params: { id: item.id_kecamatan },
        query: {
          desa: item.desa,
          nama: item.nama_kecamatan,
        },
      });
    },
  },
};
</script>

<style scoped>
.modern-desa-grid {
  row-gap: 24px;
}

.modern-desa-card {
  position: relative;
  overflow: hidden;

  border-radius: 28px !important;

  background: rgba(255, 255, 255, 0.78) !important;

  backdrop-filter: blur(20px);

  border: 1px solid rgba(255, 255, 255, 0.35);

  min-height: 235px;

  padding: 22px;

  transition: all 0.35s ease;

  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.5);

  cursor: pointer;
}

.modern-desa-card:hover {
  transform: translateY(-10px) scale(1.02);

  box-shadow: 0 20px 45px rgba(1, 140, 116, 0.22);
}

.card-glow {
  position: absolute;
  width: 180px;
  height: 180px;

  background: radial-gradient(circle, rgba(1, 140, 116, 0.18), transparent 70%);

  top: -70px;
  right: -70px;

  border-radius: 50%;
}

.desa-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 28px;
}

.icon-wrapper {
  width: 58px;
  height: 58px;

  border-radius: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(90deg, #016b62 0%, #018c74 45%, #8bcdc6 100%);

  box-shadow: 0 12px 24px rgba(1, 140, 116, 0.3);
}

.desa-badge {
  padding: 7px 12px;

  border-radius: 999px;

  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;

  background: rgba(0, 200, 83, 0.12);

  color: #00a152;
}

.desa-body {
  position: relative;
  z-index: 2;
}

.mini-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;

  color: #018c74;

  margin-bottom: 14px;
}

.desa-name {
  font-size: 1.35rem;
  line-height: 1.35;
  font-weight: 800;

  color: #1f2937;

  margin-bottom: 20px;

  min-height: 70px;
}

.kecamatan-chip {
  display: inline-flex;
  align-items: center;

  padding: 8px 14px;

  border-radius: 999px;

  background: rgba(1, 140, 116, 0.08);

  color: #018c74;

  font-size: 12px;
  font-weight: 700;
}

.desa-footer {
  margin-top: 26px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lihat-text {
  font-weight: 700;
  color: #111827;
}

.arrow-btn {
  width: 42px;
  height: 42px;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(90deg, #016b62 0%, #018c74 45%, #8bcdc6 100%);

  transition: all 0.3s ease;
}

.modern-desa-card:hover .arrow-btn {
  transform: rotate(8deg) scale(1.08);
}

@media (max-width: 768px) {
  .modern-desa-card {
    min-height: 210px;
    padding: 18px;
  }

  .desa-name {
    font-size: 1.15rem;
    min-height: auto;
  }

  .icon-wrapper {
    width: 50px;
    height: 50px;
  }}
:root {
  --bg-teal: #018c74;
  --bg-teal-dark: #016b62;
  --bg-teal-light: #8bcdc6;
  --bone-white: #f5f5f5;
  --bone-light: #fafafa;
  --text-primary: #2e2e2e;
  --accent-gold: #ffa726;
  --accent-teal: #018c74;
}


.scrollable-content-area {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  padding-right: 8px;
}

.desa-tile-v2 {
  background: #fafafa !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(45, 138, 122, 0.25) !important;
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.desa-tile-v2:hover {
  transform: translateY(-5px);
  border-color: var(--accent-teal) !important;
  background: rgba(45, 138, 122, 0.08) !important;
  box-shadow: 0 16px 40px rgba(38, 166, 154, 0.25);
}

.accent-top-bar {
  height: 4px;
  width: 100%;
  background: linear-gradient(90deg, var(--accent-teal), var(--accent-gold));
  position: absolute;
  top: 0;
  left: 0;
}

.icon-orb-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.orb-glow {
  position: absolute;
  width: 50px;
  height: 50px;
  background: radial-gradient(circle, rgba(255, 167, 38, 0.25) 0%, transparent 70%);
  border-radius: 50%;
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.15);
    opacity: 0.9;
  }
}

.gold--text {
  color: var(--accent-gold) !important;
}
.letter-spacing-2 {
  letter-spacing: 2px;
}
.letter-spacing-4 {
  letter-spacing: 4px;
}
.line-decorator-gold {
  width: 40px;
  height: 4px;
  background: var(--accent-gold);
  border-radius: 2px;
}

.corner-tl {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 8px;
  height: 8px;
  border-left: 2px solid var(--accent-teal);
  border-top: 2px solid var(--accent-teal);
  opacity: 0.6;
}
.corner-br {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-right: 2px solid var(--accent-gold);
  border-bottom: 2px solid var(--accent-gold);
  opacity: 0.6;
}

@media (max-width: 768px) {
  .desa-tile-v2:hover {
    transform: translateY(-3px);
  }
  .accent-top-bar {
    height: 3px;
  }}


.futuristic-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
